<template>
    <div class="scroll-container">
        <p class="title">  语种：{{id.name}}</p>
        <div style="margin-bottom: 12px">
        <a-button type="primary" :disabled="!hasSelected" :loading="loading" @click="editLanguage" v-has="'btn_edit'" style=" margin-top: 10px">
            编辑语种内容
        </a-button >
        <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `选中 ${selectedRowKeys.length} 项` }}
        </template>
      </span>
        </div>
        <a-table
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                :columns="columns"
                :data-source="data"
                :loading="loading"
                rowKey="a_langset_field_id"
                :pagination="pagination"
        >
         <span slot="status" slot-scope="text, record">
      </span>
            <span slot="action" slot-scope="text, record">
                <i v-if="$_hasAll(['btn_edit'])" style="color:#838383">暂无操作权限</i>
            <a @click="(record)=>{visibleForm = true; fieldId={a_langset_id:id.id,a_langset_name:id.name,a_langset_field_id:text.a_langset_field_id,a_langset_field_name:text.a_langset_field_name} ; titleForm='编辑语种内容' }" class="btntable" v-has="'btn_edit'">编辑语种内容</a>
      </span>
        </a-table>
        <LanguageForm :visible="visibleForm" :title="titleForm" :editId="fieldId" :pageNum="pageNum"
                   @changVisible=" () => { this.visibleForm = false;this.fieldId='';  this.getList(pageNum)}  "></LanguageForm>
    </div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../utils/utils"
    import LanguageForm from "./components/languageForm"
    import API from "./api"
    const columns =  [
        {
            title: "ID",
            dataIndex: "a_langset_field_id",
            key: "a_langset_field_id",
            width: "8%",
        },
        {
            title: "字段名称",
            dataIndex: "a_langset_field_name",
            ellipsis: true,
            key: "a_langset_field_name",
        },
        {
            title: "字段描述",
            dataIndex: "a_langset_field_abstract",
            ellipsis: true,
            key: "a_langset_field_abstract",
        },
        {
            title: "值",
            key: "content",
            ellipsis: true,
            dataIndex: "content",
        },
        {
            title: "编辑时间",
            key: "update_time",
            ellipsis: true,
            dataIndex: "update_time",
        },

        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: "ManageLanguagePack",
        data(){
            return{
                pageNum:"",
                id: this.$route.query,
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                selectedRowKeys: [], // Check here to configure the default column
                loading: true,
                sortLists:[],
                data:[],
                columns,
                visiblezd:false,
                visiblebj:false,
                visibleForm: false,
                titleForm: "",
                editId: null,
                fieldId:null,
            }
        },
        components:{LanguageForm},
        created() {
            this.$store.state.adminleftnavnum = "/UserBackground/LanguagePack"; //设置左侧导航2-2 active
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        mounted(){
            this.getList()
        },
        methods:{
            getList(page) {
                this.pageNum=page
                // console.log(this.pageNum)
                API.language.GET_LANGUAGEPACK({page:page||1,a_langset_id:this.id.id,a_langset_name:this.id.name}).then(res => {
                    this.pagination.total=res.data.data.total
                    this.pagination.pageSize=res.data.data.per_page
                    this.pagination.current=res.data.data.current_page
                    this.data = res.data.data.data
                    this.loading = false
                })
            },
            editLanguage(){
                this.visibleForm = true;
                this.titleForm='编辑语种内容'
                this.fieldId={a_langset_id:this.id.id,a_langset_name:this.id.name,a_langset_field_id:this.selectedRowKeys}
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
        }
    }
</script>

<style scoped>
.title{font-weight: bold;font-size: 16px;margin-left: 5px}
.scroll-container{height: calc(100vh - 200px);overflow: auto}
.scroll-container::-webkit-scrollbar { width: 8px; background: white;  }
.scroll-container::-webkit-scrollbar-corner, .scroll-container::-webkit-scrollbar-thumb, .scroll-container::-webkit-scrollbar-track { border-radius: 4px; }
.scroll-container::-webkit-scrollbar-corner,.scroll-container::-webkit-scrollbar-track {  background-color: #ddd; box-shadow: inset 0 0 1px #ddd; }
.scroll-container::-webkit-scrollbar-thumb {  background-color: #c1c1c1; }

</style>
